export const MANAGE_GUESTS_FILTER_QUERY_PARAM = 'filter'
